module.exports = __webpack_public_path__ + "img/d2.f6ecb3d7.jpg";